<template>
  <div>
    <v-app-bar app color="deep-purple" dark clipped-left>
      <v-app-bar-nav-icon @click.stop="toggleDrawer"></v-app-bar-nav-icon>
      <v-toolbar-title @click="logoClick" style="cursor: pointer">Finastra</v-toolbar-title>
      <v-spacer></v-spacer>
      <Search />
      <v-btn icon target="_blank" name="help-url" class="">
        <v-icon>mdi-help-circle-outline</v-icon>
      </v-btn>
      <v-btn icon target="_blank" name="settings" class="">
        <v-icon>mdi-cog</v-icon>
      </v-btn>
      <UserProfile />
    </v-app-bar>
  </div>
</template>
<script>
import UserProfile from "./UserProfile.vue";
import Search from "./Search.vue";
import event from "../eventBus.js";

export default {
  name: "Header",
  data: () => ({
    group: null,
    drawer: false,
    drawerItems: [],
    mini: true,
  }),
  components: {
    UserProfile,
    Search
  },
  methods: {
    toggleDrawer() {
      this.drawer = !this.drawer;
      this.mini = !this.mini;
      event.$emit("toggleDrawer", true);
    },
    logoClick() {
      if(this.$route.name !== 'Dashboard') {
          this.$router.push({name: 'Dashboard'})
      }
    }
  },
};
</script>
